import { Typography } from 'antd';
import styled from 'styled-components';

export const Title = styled(Typography.Text)`
  color: currentcolor;
`;
